import { api } from "../api";

export const getRps = async () => {
  try {
    const url = "/rps";
    let response = await api.get(url);
    return response.data ? response.data : [];
  } catch (error) {
    console.log(error);
  }
};
